export default "#version 300 es\n\nprecision mediump float;\n\nin vec4 v_color;\n\nout vec4 o_color;\n\nvoid main() {\n  o_color = v_color;\n}\n"